<script>
  import { t } from "totalinvoice-frontend-core"
  import { createFieldValidator, email, required } from "totalinvoice-frontend-core"
  import { emptyCustomer } from '../stores/Customer'
  import { FormNotice } from 'totalinvoice-frontend-core'
  import { CUSTOMER_TITLE_VALUE_OTHER } from 'totalinvoice-frontend-core'

  export let customer = emptyCustomer()

  export function resetCustomer() {
    customer = emptyCustomer()
  }

  let checkedErrors = {}

  export let editable = true

  export let showErrors = true

  const [ vatFieldValidity, vatFieldValidate ] = createFieldValidator(required('VAT number is required'))
  const [ companyTypeFieldValidity, companyTypeFieldValidate ] = createFieldValidator(required('Type is required'))
  const [ companyNameFieldValidity, companyNameFieldValidate ] = createFieldValidator(required('Name is required'))
  const [ civilityFieldValidity, civilityFieldValidate ] = createFieldValidator(required('Civility is required'))
  const [ firstNameFieldValidity, firstNameFieldValidate ] = createFieldValidator(required('First name is required'))
  const [ lastNameFieldValidity, lastNameFieldValidate ] = createFieldValidator(required('Last name is required'))
  const [ streetFieldValidity, streetFieldValidate ] = createFieldValidator(required('Address is required'))
  const [ zipFieldValidity, zipFieldValidate ] = createFieldValidator(required('Zip/Postal code is required'))
  const [ cityFieldValidity, cityFieldValidate ] = createFieldValidator(required('City is required'))
  const [ countryFieldValidity, countryFieldValidate ] = createFieldValidator(required('Country is required'))
  const [ emailFieldValidity, emailFieldValidate ] = createFieldValidator(required('E-mail is required'), email('E-mail is invalid'))
  const [ freeTextFieldValidity, freeTextFieldValidate ] = createFieldValidator()

  $: privateCustomerFieldsAreValid = $civilityFieldValidity.valid && $firstNameFieldValidity.valid && $lastNameFieldValidity.valid
  $: companyCustomerFieldsAreValid = $vatFieldValidity.valid && $companyNameFieldValidity.valid
  $: commonFieldsAreValid = $streetFieldValidity.valid && $zipFieldValidity.valid && $cityFieldValidity.valid && $countryFieldValidity.valid && $emailFieldValidity.valid && $freeTextFieldValidity.valid

  export let allFieldsAreValid = false
  $: allFieldsAreValid = (customer.isprivate ? privateCustomerFieldsAreValid : companyCustomerFieldsAreValid) && commonFieldsAreValid

  // match civilities and company types with title number from Ed-Fr database
  // TODO dynamically check for numbers that have equal translated values
  const civilities = [ 1, 2, 3, 10, 11 ]
  const companyTypes = [ 4, 5, 6, 7, 8, 9, 12, 13, 14, 15, 16, 17, 0 ]

  const countries = [ // TODO use data from Ed-Fr database
    /*{ value: 'BE', label: 'Belgium' },
    { value: 'FR', label: 'France' },
    { value: 'DE', label: 'Germany' },
    { value: 'NL', label: 'Netherlands' }
    */
    { value: 'FR', label: 'France' },
    { value: 'BE', label: 'Belgium' },
    { value: 'DE', label: 'Germany' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'NL', label: 'The Netherlands' },
    { value: 'ES', label: 'Spain' },
    { value: 'PT', label: 'Portugal' },
    { value: 'IT', label: 'Italy' },
    { value: 'GB', label: 'The United Kingdom' },
    { value: 'CH', label: 'Switzerland' },
    { value: 'DK', label: 'Denmark' },
    { value: 'AT', label: 'Austria' },
    { value: 'BG', label: 'Bulgaria' },
    { value: 'FI', label: 'Finland' },
    { value: 'HU', label: 'Hungary' },
    { value: 'PL', label: 'Poland' },
    { value: 'RO', label: 'Romania' },
    { value: 'SK', label: 'Slovakia' },
    { value: 'SI', label: 'Slovenia' },
    { value: 'SE', label: 'Sweden' },
    { value: 'EE', label: 'Estonia' },
    { value: 'LV', label: 'Latvia' },
    { value: 'LT', label: 'Lithuania' },
    { value: 'CZ', label: 'Czech Republic' },
    { value: 'HR', label: 'Croatia' },
    { value: 'GR', label: 'Greece' },
    { value: 'MK', label: 'Macedonia' },
    { value: 'CM', label: 'Cameroon' },
    { value: 'LB', label: 'Lebanon' },
    { value: 'GQ', label: 'Equatorial Guinea' },
    { value: 'TN', label: 'Tunisia' },
    { value: 'GB', label: 'Northern Ireland' },
    { value: 'FJ', label: 'Fidji' },
    { value: 'EG', label: 'Egypt' },
    { value: 'MU', label: 'Mauritius' },
    { value: 'UG', label: 'Uganda' },
    { value: 'IE', label: 'Ireland' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'CG', label: 'Congo' },
    { value: 'PF', label: 'French Polynesia' },
    { value: 'MA', label: 'Morocco' },
    { value: 'TZA', label: 'Tanzania' },
    { value: 'NG', label: 'Nigeria' },
    { value: 'GA', label: 'Gabon' },
    { value: 'TCD', label: 'Tchad' },
    { value: 'KE', label: 'Kenya' },
    { value: 'GH', label: 'Ghana' },
    { value: 'MW', label: 'Malawi' },
    { value: 'NE', label: 'Niger' },
    { value: 'TG', label: 'Togo' },
    { value: 'CI', label: 'Côte d\'Ivoire' },
    { value: 'ML', label: 'Mali' },
    { value: 'SL', label: 'Sierra Leone' },
    { value: 'MZ', label: 'Mozambique' },
    { value: 'CF', label: 'Centrafrique' },
    { value: 'SN', label: 'Senegal' },
    { value: 'BFA', label: 'Burkina Faso' },
    { value: 'CD', label: 'République Démocratique du Congo' },
    { value: 'GN', label: 'Guinée Conakry' },
    { value: 'ZWE', label: 'Zimbabwe' },
    { value: 'AUS', label: 'Australia' },
    { value: 'HND', label: 'Honduras' },
    { value: 'NCL', label: 'Nouvelle-Calédonie' },
    { value: 'KE', label: 'Kenya' },
    { value: 'PNG', label: 'Papouasie Nouvelle Guinée' },
    { value: 'ZM', label: 'Zambia' },
    { value: 'MDG', label: 'Madagascar' },
    { value: 'LBR', label: 'Liberia' },
    { value: 'GLP', label: 'Guadeloupe' },
    { value: 'KSA', label: 'Kingdom of Saudi Arabia' },
    { value: 'SRB', label: 'Serbia' },
    { value: 'MNE', label: 'Montenegro' },
    { value: 'RKS', label: 'Kosovo' },
    { value: 'BIH', label: 'Bosnia and Herzegovina' },
    { value: 'BRB', label: 'Barbados' },
    { value: 'AGO', label: 'Angola' },

  ]

  export function setErrors(errors) {
    checkedErrors = errors
  }

  function clearError(key) {
    delete checkedErrors[key]
  }

  function showError(key, validity) {
    return (editable && !validity.valid) ? $t(validity.message) : (checkedErrors[key] ? checkedErrors[key] : "")
  }

  function onCompanyTabClicked() {
    if (!customer.isprivate) return
    customer.title = ""
    customer.first_name = ""
    customer.last_name = ""
    customer.isprivate = false
    showErrors = false
  }

  function onPrivateTabClicked() {
    if (customer.isprivate) return
    customer.vatno = ""
    customer.last_name = ""
    customer.isprivate = true
    showErrors = false
  }
</script>

<div class="form">

{#if editable}
<div class="field is-horizontal mb-5">
  <div class="field-label"></div>
  <div class="field-body">
    <div class="field tabs is-toggle">
      <ul>
        <li class:is-active={!customer.isprivate}>
          <a href on:click|preventDefault={onCompanyTabClicked}>
            <span class="icon is-small"><i class="fas fa-building" aria-hidden="true"></i></span>
            <span>{$t('Company')}</span>
          </a>
        </li>
        <li class:is-active={customer.isprivate}>
          <a href on:click|preventDefault={onPrivateTabClicked}>
            <span class="icon is-small"><i class="fas fa-user-tie" aria-hidden="true"></i></span>
            <span>{$t('Private')}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
{/if}

{#if customer.isprivate}

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}>
    <label for class="label" class:required={editable}>{customer.isprivate ? $t('Civility') : $t('Type')}</label>
  </div>
  <div class="field-body">
    <div class="field is-narrow">
      <div class="control">
        {#if editable}
          <div
              class="select is-fullwidth"
              class:is-danger={showErrors && (checkedErrors["title"] || $civilityFieldValidity.dirty && !$civilityFieldValidity.valid)}>
            <select
                bind:value={customer.title}
                use:civilityFieldValidate={customer.title}
                on:keydown={() => clearError("title")}>
              <option value="" selected disabled>{$t('Please select')}</option>
              {#each civilities as titleNo}
                <option value={$t(`customer_title_${titleNo}`)}>{$t(`customer_title_${titleNo}`)}</option>
              {/each}
            </select>
          </div> 
        {:else}
          {$t(customer.title)}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["title"] || $civilityFieldValidity.dirty && !$civilityFieldValidity.valid)}
        <p class="help is-danger">{showError("title",$civilityFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('Civility')}</p>
      {/if}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}>
    <label for class="label" class:required={editable}>{$t('Name')}</label>
  </div>
  <div class="field-body">
    <div class="field" class:is-narrow={!editable}>
      <div class="control">
        {#if editable}
          <input class="input"
              class:is-danger={showErrors && (checkedErrors["first_name"] ||  $firstNameFieldValidity.dirty && !$firstNameFieldValidity.valid)}
              type="text"
              bind:value={customer.first_name}
              use:firstNameFieldValidate={customer.first_name}
              on:keydown={() => clearError("first_name")}>
        {:else}
          {customer.first_name}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["first_name"] ||  $firstNameFieldValidity.dirty && !$firstNameFieldValidity.valid)}
        <p class="help is-danger">{showError("first_name",$firstNameFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('First name')}</p>
      {/if}
    </div>
    <div class="field">
      <div class="control">
        {#if editable}
          <input class="input"
              class:is-danger={showErrors && (checkedErrors["last_name"] ||  $lastNameFieldValidity.dirty && !$lastNameFieldValidity.valid)}
              type="text"
              bind:value={customer.last_name}
              use:lastNameFieldValidate={customer.last_name}
              on:keydown={() => clearError("last_name")}>
        {:else}
          {customer.last_name}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["last_name"] ||  $lastNameFieldValidity.dirty && !$lastNameFieldValidity.valid)}
        <p class="help is-danger">{showError("last_name",$lastNameFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('Last name')}</p>
      {/if}
    </div>
  </div>
</div>

{:else}

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}>
    <label for class="label" class:required={editable}>{'Type'}</label>
  </div>
  <div class="field-body">
    <div class="field is-narrow">
      <div class="control">
        {#if editable}
          <div
              class="select is-fullwidth"
              class:is-danger={showErrors && (checkedErrors["title"] || $companyTypeFieldValidity.dirty && !$companyTypeFieldValidity.valid)}>
            <select
                bind:value={customer.title}
                use:companyTypeFieldValidate={customer.title}
                on:keydown={() => clearError("title")}>
              <option value="" selected disabled>{$t('Please select')}</option>
              {#each companyTypes as titleNo}
                <option value={titleNo === 0 ? CUSTOMER_TITLE_VALUE_OTHER : $t(`customer_title_${titleNo}`)}>{$t(`customer_title_${titleNo}`)}</option>
              {/each}
            </select>
          </div>
        {:else}
          {customer.title === CUSTOMER_TITLE_VALUE_OTHER ? $t('customer_title_0') : $t(customer.title)}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["title"] || $companyTypeFieldValidity.dirty && !$companyTypeFieldValidity.valid)}
        <p class="help is-danger">{showError("title",$companyTypeFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('Company type')}</p>
      {/if}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}>
    <label for class="label" class:required={editable}>{$t('Name')}</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        {#if editable}
          <input class="input"
              class:is-danger={showErrors && (checkedErrors["last_name"] || $companyNameFieldValidity.dirty && !$companyNameFieldValidity.valid)}
              type="text"
              bind:value={customer.last_name}
              use:companyNameFieldValidate={customer.last_name}
              on:keydown={() => clearError("last_name")}>
        {:else}
          {customer.last_name}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["last_name"] || $companyNameFieldValidity.dirty && !$companyNameFieldValidity.valid)}
        <p class="help is-danger">{showError("last_name",$companyNameFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('Company name')}</p>
      {/if}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}>
    <label for class="label" class:required={editable}>{$t('VAT')}</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        {#if editable}
          <input class="input"
              class:is-danger={showErrors && (checkedErrors["vatno"] || $vatFieldValidity.dirty && !$vatFieldValidity.valid)}
              type="text"
              bind:value={customer.vatno}
              use:vatFieldValidate={customer.vatno}
              on:keydown={() => clearError("vatno")}>
        {:else}
          {customer.vatno}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["vatno"] ||  $vatFieldValidity.dirty && !$vatFieldValidity.valid)}
        <p class="help is-danger">{showError("vatno",$vatFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('VAT number')}</p>
        <p class="help">{$t('Starts with an country code (usually 2 letters) followed by up to 13 characters, e.g. BE09999999XX, FRXX999999999, NL999999999B01')}</p>
      {/if}
    </div>
  </div>
</div>

{/if}

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}>
    <label for class="label" class:required={editable}>{$t('Address')}</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        {#if editable}
          <input class="input"
              class:is-danger={showErrors && (checkedErrors["street"] ||  $streetFieldValidity.dirty && !$streetFieldValidity.valid)}
              type="text" bind:value={customer.street}
              use:streetFieldValidate={customer.street}
              on:keydown={() => clearError("street")}>
        {:else}
          {customer.street}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["street"] ||  $streetFieldValidity.dirty && !$streetFieldValidity.valid)}
        <p class="help is-danger">{showError("street",$streetFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('Street address')}</p>
      {/if}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}></div>
  <div class="field-body">
    <div class="field is-narrow">
      <div class="control">
        {#if editable}
          <input class="input"
              class:is-danger={showErrors && (checkedErrors["zip_code"] ||  $zipFieldValidity.dirty && !$zipFieldValidity.valid)}
              type="text"
              bind:value={customer.zip_code}
              use:zipFieldValidate={customer.zip_code}
              on:keydown={() => clearError("zip_code")}>
        {:else}
          {customer.zip_code}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["zip_code"] || $zipFieldValidity.dirty && !$zipFieldValidity.valid)}
        <p class="help is-danger">{showError("zip_code",$zipFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('Zip/Postal code')}</p>
      {/if}
    </div>
    <div class="field">
      <div class="control">
        {#if editable}
          <input class="input"
              class:is-danger={showErrors && (checkedErrors["city"] ||  $cityFieldValidity.dirty && !$cityFieldValidity.valid)}
              type="text"
              bind:value={customer.city}
              use:cityFieldValidate={customer.city}
              on:keydown={() => clearError("city")}>
        {:else}
          {customer.city}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["city"] ||  $cityFieldValidity.dirty && !$cityFieldValidity.valid)}
        <p class="help is-danger">{showError("city", $cityFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('City')}</p>
      {/if}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}></div>
  <div class="field-body">
    <div class="field is-narrow">
      <div class="control">
        {#if editable}
          <div class="select is-fullwidth"
              class:is-danger={showErrors && (checkedErrors["country"] || $countryFieldValidity.dirty && !$countryFieldValidity.valid)}>
            <select
                bind:value={customer.country}
                use:countryFieldValidate={customer.country}
                on:keydown={() => clearError("country")}>
              <option value="" selected disabled>{$t('Please select')}</option>
              {#each countries as country}
                <option value={country.value}>{$t(country.label)}</option>
              {/each}
          </div>
        {:else}
          {customer.country}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["country"] || $countryFieldValidity.dirty && !$countryFieldValidity.valid)}
        <p class="help is-danger">{showError("country", $countryFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('Country')}</p>
      {/if}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}>
    <label for class="label" class:required={editable}>{$t('E-mail')}</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        {#if editable}
          <input class="input"
              class:is-danger={showErrors && (checkedErrors["email"] ||  $emailFieldValidity.dirty && !$emailFieldValidity.valid)}
              type="email"
              bind:value={customer.email}
              use:emailFieldValidate={customer.email}
              on:keydown={() => clearError("email")}>
        {:else}
          {customer.email}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["email"] ||  $emailFieldValidity.dirty && !$emailFieldValidity.valid)}
        <p class="help is-danger">{showError("email",$emailFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('E-mail')}</p>
      {/if}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}>
    <label for class="label">{$t('Free text')}</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        {#if editable}
          <input class="input"
              class:is-danger={showErrors && (checkedErrors["freetext"] ||  $freeTextFieldValidity.dirty && !$freeTextFieldValidity.valid)}
              type="text"
              bind:value={customer.freetext}
              use:freeTextFieldValidate={customer.freetext}
              on:keydown={() => clearError("freetext")}>
        {:else}
          {customer.freetext}
        {/if}
      </div>
      {#if showErrors && (checkedErrors["freetext"] || $freeTextFieldValidity.dirty && !$freeTextFieldValidity.valid)}
        <p class="help is-danger">{showError("freetext",$freeTextFieldValidity)}</p>
      {:else if editable}
        <p class="help">{$t('Free text')}</p>
      {/if}
    </div>
  </div>
</div>

{#if editable}
<div class="field is-horizontal">
  <div class="field-label" class:is-normal={editable}></div>
  <div class="field-body">
    <div class="field is-narrow">
      <div class="control">
        <FormNotice />
      </div>
    </div>
  </div>
</div>
{/if}

</div>
